import { createAction, props } from '@ngrx/store';
import { AppSetting } from '@klubovna/api-client';

export const ADMIN_APP_SETTINGS_ID = '[AppSettings admin]';

export const loadSettings = createAction(
  ADMIN_APP_SETTINGS_ID + ' Load Settings',
);

export const loadSettingsSuccess = createAction(
  ADMIN_APP_SETTINGS_ID + ' Load Settings Success',
  props<{ settings: AppSetting[] }>(),
);

export const loadSettingsFailure = createAction(
  ADMIN_APP_SETTINGS_ID + ' Load Settings Failure',
  props<{ error: string }>(),
);

export const updateSetting = createAction(
  ADMIN_APP_SETTINGS_ID + ' Update Setting',
  props<{ key: string; value: string }>(),
);

export const updateSettingSuccess = createAction(
  ADMIN_APP_SETTINGS_ID + ' Update Setting Success',
  props<{ setting: AppSetting }>(),
);

export const updateSettingFailure = createAction(
  ADMIN_APP_SETTINGS_ID + ' Update Setting Failure',
  props<{ error: string }>(),
);
